module.exports = __webpack_public_path__ + "static/media/circle-export.6ef60a4e.svg";